module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_miyagi-319592a29318307ac7c93e3e102d9376.png";